import React from "react";
import { inject, observer } from "mobx-react";
import { Location, NavigateFunction } from "react-router-dom";
import SearchIcon from "../../../../../images/common/search-blue.svg";
// import MerchantAccountIcon from "../../../../../images/sidebar/merchant-accounts-icon-blue.svg";
import NewItemDropDown from "./NewItemDropDown";
import ItemsStore from "../store/ItemsStore";
import {
  ItemSideBarModel,
  MerchantAccount,
  SubscriptionModel,
  UpsertInvoiceModel,
  UpsertPaymentModel,
} from "../models";
import { ItemDropDownOptions } from "../enums";
import NewSubscriptionPopUp from "./NewSubscriptionPopUp";
import UpsertPaymentPopUp from "./UpsertPaymentPopUp";
import UpsertInvoicePopUp from "./UpsertInvoicePopUp";
import NewContactPopup from "./NewContactPopup";
import {
  AuthService,
  FlexContainer,
  Input,
  SapphireBlueButton,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import { RolesAndPermissionStore } from "../store";
import MerchantPortalPopUp from "./MerchantPortalPopUp";

interface IProps {
  itemStore: ItemsStore;
  location: Location;
  navigate: NavigateFunction;
  rolesAndPermissionStore: RolesAndPermissionStore;
  showMerchantPortalButton?: boolean;
  showSearchInput?: boolean;
  showButton?: boolean;
  selectedMerchantAccount?: MerchantAccount;
  onRefresh?: () => void;
  /* Extra controls a page wants in this bar, rendered between the search and the New button.
     Payments uses it for its Export dropdown; pages that pass nothing are unchanged. */
  extraContent?: React.ReactNode;
}
const DashboardTopRightSide: React.FC<IProps> = ({
  itemStore,
  location,
  navigate,
  rolesAndPermissionStore,
  selectedMerchantAccount,
  showMerchantPortalButton = false,
  showSearchInput = true,
  showButton = true,
  onRefresh,
  extraContent,
}) => {
  const activeRoute = ItemSideBarModel.getActiveRoute(location);
  const [openPopUp, setOpenPopUp] = React.useState("");
  const [showMerchantPopUp, setShowMerchantPopUp] = React.useState(false);

  function getTitle() {
    if (!activeRoute?.title) return "";
    if (activeRoute.title.charAt(activeRoute.title.length - 1) === "s") {
      return activeRoute.title.slice(0, -1);
    }
    return activeRoute.title;
  }

  function onClick(
    buttonText: string,
    title?: keyof typeof ItemDropDownOptions
  ) {
    const hasPermission =
      rolesAndPermissionStore.hasManagePermission(buttonText);
    if (!hasPermission) return;
    const route = title ? title : activeRoute?.title;
    if (!route) return;
    switch (route) {
      case ItemDropDownOptions.Checkout:
        navigate(AuthService.prefixRoute + "checkout/detail");
        break;
      case ItemDropDownOptions.Donations:
        navigate(AuthService.prefixRoute + "donation/detail");
        break;
      case ItemDropDownOptions.Subscriptions:
        setOpenPopUp("subscription");
        break;
      case ItemDropDownOptions.Payments:
        setOpenPopUp("payment");
        break;
      case ItemDropDownOptions.Invoices:
        setOpenPopUp("invoice");
        break;
      case ItemDropDownOptions.Contacts:
        setOpenPopUp("contact");
        break;
      default:
        break;
    }
  }

  function closePopPup(refresh: boolean) {
    setOpenPopUp("");
    if (getTitle() === "Activity" && refresh) {
      window.location.reload();
    } else if (refresh && onRefresh) {
      onRefresh();
    }
  }

  function showPopUp() {
    switch (openPopUp) {
      case "subscription":
        return (
          <NewSubscriptionPopUp
            subscriptionData={new SubscriptionModel()}
            onClose={(refresh) => closePopPup(refresh)}
            countriesWithState={itemStore.countryStore.countriesWithState}
          />
        );
      case "payment":
        return (
          <UpsertPaymentPopUp
            onClose={(refresh: boolean) => closePopPup(refresh)}
            paymentData={new UpsertPaymentModel()}
            countriesWithState={itemStore.countryStore.countriesWithState}
          />
        );
      case "invoice":
        return (
          <UpsertInvoicePopUp
            onClose={(refresh: boolean) => closePopPup(refresh)}
            invoiceData={new UpsertInvoiceModel()}
            countriesWithState={itemStore.countryStore.countriesWithState}
          />
        );
      case "contact":
        return (
          <NewContactPopup
            onClose={(refresh: boolean) => closePopPup(refresh)}
            countriesWithState={itemStore.countryStore.countriesWithState}
          />
        );
      default:
        return null;
    }
  }

  function getSearchValue() {
    switch (activeRoute?.title) {
      case "Subscriptions":
        return itemStore.subscriptionStore.searchValue;
      case "Payments":
        return itemStore.paymentStore.searchValue;
      case "Invoices":
        return itemStore.invoiceStore.searchValue;
      case "Items":
        return itemStore.searchValue;
      case "Checkout":
        return itemStore.checkoutSearchValue;
      case "Contacts":
        return itemStore.contactStore.searchValue;
      case "Donations":
        return itemStore.searchValue;
      default:
        return "";
    }
  }

  const onClickMerchantPortal = () => {
    // setShowMerchantPopUp(true);
    selectedMerchantAccount?.goToMerchantPortal();
  };

  const renderMerchantPopUp = () => {
    return (
      <MerchantPortalPopUp
        selectedMerchantAccount={selectedMerchantAccount}
        onClickLogin={() => {
          setShowMerchantPopUp(false);
        }}
        onClose={() => setShowMerchantPopUp(false)}
      />
    );
  };

  function getButtonText() {
    return getTitle() === "Activity" ? "Create" : "New " + getTitle();
  }

  function renderMerchantPortal() {
    if (!showMerchantPortalButton) return null;
    if (!selectedMerchantAccount) return null;

    if (
      selectedMerchantAccount.isFiservMerchantAccount() ||
      selectedMerchantAccount.isNMIMerchantAccount()
    )
      return (
        <FlexContainer>
          <SapphireBlueButton
            onClick={() => onClickMerchantPortal()}
            height="40px"
            minWidth="165px"
          >
            {selectedMerchantAccount.isFiservMerchantAccount()
              ? "Merchant Portal"
              : "NMI Portal"}
          </SapphireBlueButton>
        </FlexContainer>
      );

    return null;
  }
  return (
    <div>
      <FlexContainer spacing={20} alignItems="center">
        {showPopUp()}
        {showMerchantPopUp && renderMerchantPopUp()}
        {showSearchInput && (
          <div>
            <FlexContainer
              spacing={5}
              alignItems="center"
              className="db-search-input"
            >
              <img src={SearchIcon} />
              <Input
                type="text"
                value={getSearchValue()}
                onChange={(e) =>
                  itemStore.updateSearchValue(
                    e.target.value,
                    activeRoute?.title
                  )
                }
                placeholder="Search"
              />
            </FlexContainer>
          </div>
        )}
        {renderMerchantPortal()}
        {extraContent}
        {showButton && (
          <div style={{ position: "relative" }}>
            <NewItemDropDown
              header={getButtonText()}
              onHeaderClick={(title?: keyof typeof ItemDropDownOptions) =>
                onClick(getButtonText(), title)
              }
              showSplitDropdown={getTitle() === "Activity" ? true : false}
            />
          </div>
        )}
      </FlexContainer>
    </div>
  );
};

export default inject("rolesAndPermissionStore")(
  withRouter(observer(DashboardTopRightSide))
);
